module.exports = __webpack_public_path__ + "static/media/coursera.3e9175a8.png";